import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAsset } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class AssetService extends ODataService<IAsset, number> {
    protected _endpoint = '/odata/Assets';
    constructor(http: HttpClient) {
        super(http, MapperService.assetMap);
    }
}
